<template>  
  <div>
    <q-card inline style="width: 280px">
      <q-card-title>
        <q-toolbar color="primary">
        <q-toolbar-title>
          {{$t('global.ChangePassword')}}
        </q-toolbar-title>
        </q-toolbar>
      </q-card-title>
      <q-card-separator />
      <q-card-main>

        <q-input v-model="PasswordOld" type="password" :stack-label="$t('global.OldPassword')" />
        <p class="error" v-if="submited && PasswordOldError">{{ PasswordOldError }}</p>

        <q-input v-model="PasswordNew1" type="password" :stack-label="$t('global.NewPassword')" />
        <p class="error" v-if="submited && PasswordNew1Error">{{ PasswordNew1Error }}</p>

         <q-input v-model="PasswordNew2" type="password" :stack-label="$t('global.NewPasswordRepeat')" />
        <p class="error" v-if="submited && PasswordNew2Error">{{ PasswordNew2Error }}</p>

        <q-btn class="button" @click="savePassword()" color="primary" :label="$t('global.Save')" />
           
        
      </q-card-main>
    </q-card>   
  </div>
</template>

<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogGeoRegionNew',
  data () {
    return {
      
      PasswordOld: '',
      PasswordOldError: null,

      PasswordNew1: '',
      PasswordNew1Error: null,

      PasswordNew2: '',
      PasswordNew2Error: null,
      
      form: {
        SessionId: null,
        action: 'InsertUser',
      },
      submited: false,
      title: null,
      validationRequired: this.$t('global.EntryRequired'),
      validationEmail: this.$t('global.InvalidEmail'),
      validationPassword: this.$t('global.NotSafeEnugh'),
      validationPasswordSame: this.$t('global.PasswordNotEqual')
      
    }
  },
  methods: {
    savePassword(){
      this.submited = true
      if(this.validate()){
        this.updatePassword()
      }
    },

    validate(){
        var valid = true

        if(this.PasswordOld == ''){
          this.PasswordOldError = this.validationRequired
          valid = false
        }
        else{
          this.PasswordOldError = null
        }
        
        if(this.PasswordNew1 == ''){
          this.PasswordNew1Error = this.validationRequired
          valid = false
        }
        else{
          if(!testPassword(this.PasswordNew1)){
            this.PasswordNew1Error = this.validationPassword
            valid = false
          }
          else{
            this.PasswordNew1Error = null
          }
        }

        if(this.PasswordNew2 == ''){
          this.PasswordNew2Error = this.validationRequired
          valid = false
        }
        else{
          if(this.PasswordNew2 != this.PasswordNew1){
            this.PasswordNew2Error = this.validationPasswordSame
            valid = false
          }
          else{
            this.PasswordNew2Error = null
          }
        }
        
      return valid
    },

    updatePassword(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.PasswordOld = this.PasswordOld
      this.form.PasswordNew = this.PasswordNew2
      this.form.action = "UpdatePassword"
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
             if(response.data == "OK"){
              this.$q.notify({ message: this.$t('global.PasswordUpdated'), type: 'positive' })
             }
            else{
              if(response.data == "-1"){
                this.$q.notify(this.$t('global.OldPasswordNotValid'))
                this.PasswordOldError = this.$t('global.OldPasswordNotValid')
              }
            }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    
  },
  created () {
    
  },
  
  watch: {
    PasswordOld: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    PasswordNew1: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    PasswordNew2: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
  },

}

function validateEmail(email) 
{
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function testPassword(pwString) {
    var strength = 0;

    strength += /[A-Z]+/.test(pwString) ? 1 : 0;
    strength += /[a-z]+/.test(pwString) ? 1 : 0;
    strength += /[0-9]+/.test(pwString) ? 1 : 0;
    strength += /[\W]+/.test(pwString) ? 1 : 0;

    switch(strength) {
        case 3:
            // its's medium!
            return true
            break;
        case 4:
            // it's strong!
            return true
            break;
        default:
            // it's weak!
            return false
            break;
    }
}



</script>

<style scoped>
.error {
  color: red;
}
</style>
